import { ComponentPropsWithoutRef } from 'react';
import { StyledCard } from './styles';

export const Card = (props: ComponentPropsWithoutRef<'div'>) => <StyledCard {...props} />;
